import { down } from 'styled-breakpoints';
import styled from 'styled-components';

export const PageLayoutWrapper = styled.main`
    margin: 0 ${({ theme }) => theme.spacers.medium};
    margin-bottom: ${({ theme }) => theme.spacers.medium};

    display: flex;
    flex-direction: row;
    gap: ${({ theme }) => theme.spacers.medium};
    flex: 1;

    ${down('lg')} {
        flex-direction: column;
        gap: ${({ theme }) => theme.spacers.medium};
        margin-bottom: 0;
    }
    ${down('md')} {
        gap: ${({ theme }) => theme.spacers.medium};
    }
    ${down('sm')} {
        gap: ${({ theme }) => theme.spacers.small};
        margin: 0 16px;
    }

    @media screen and (max-width: 400px) {
        margin: 0;
    }
`;

interface modalMenuProps {
    modalMenu: boolean | undefined;
}
export const ModalMenuBackground = styled.aside<modalMenuProps>`
    display: flex;
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background-color: ${({ theme }) => theme.palette.common.black};
    ${down('lg')} {
        transition: opacity 0.3s;
        ${({ modalMenu }) =>
            modalMenu ? 'pointer-events: all;' : 'pointer-events: none;'};
        ${({ modalMenu }) => (modalMenu ? 'opacity: 0.5;' : 'opacity: 0;')};
        ${({ modalMenu }) => (modalMenu ? 'z-index: 1;' : 'z-index: 0;')};
    }
`;
export const PageLayoutMenu = styled.aside<modalMenuProps>`
    width: calc(100% / 3);
    display: block;

    nav {
        position: fixed;
        padding-bottom: 72px;
        bottom: 32px;
        width: 100%;
        max-width: calc(100% / 3 - 32px);
        overflow: hidden;
        background-color: ${({ theme }) => theme.palette.common.white};
        border-radius: ${({ theme }) => theme.borderRadius.extraLarge};

        @media screen and (max-width: 400px) {
            div {
                border-radius: 0;
            }
        }
    }

    ${down('lg')} {
        width: 100%;
        height: 100%;
        position: fixed;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        left: 0;
        display: block;
        z-index: 1;
        padding: ${({ theme }) => theme.spacers.small};

        transition: opacity 0.3s;
        ${({ modalMenu }) =>
            modalMenu ? 'pointer-events: all;' : 'pointer-events: none;'};
        ${({ modalMenu }) => (modalMenu ? 'opacity: 1;' : 'opacity: 0;')};
        ${({ modalMenu }) => (modalMenu ? 'z-index: 1;' : 'z-index: 0;')};

        nav {
            transition: opacity 0.3s;
            ${({ modalMenu }) =>
                modalMenu ? 'pointer-events: all;' : 'pointer-events: none;'};
            ${({ modalMenu }) => (modalMenu ? 'opacity: 1;' : 'opacity: 0;')};
            ${({ modalMenu }) => (modalMenu ? 'z-index: 1;' : 'z-index: 0;')};
            display: flex;
            flex-direction: column-reverse;
            position: relative;
            top: 0;
            min-height: 100%;
            overflow: hidden;
            padding-bottom: 0px;
            margin: 0 auto;
            max-width: 420px;
            border: ${({ theme }) => theme.spacers.extraSmall} solid
                ${({ theme }) => theme.palette.grey.bg1};
            border-radius: 28px;
            box-sizing: border-box;
            background-color: ${({ theme }) => theme.palette.grey.bg1};
            z-index: 2;

            & > div:nth-child(3) {
                height: calc(100% - 72px);
                top: 0;
                padding: 72px 0px 0px 0px;
                z-index: 2;
            }
            & > div:nth-child(2) {
                z-index: 3;
            }

            ${down('lg')} {
                border-bottom-left-radius: ${({ theme }) =>
                    theme.borderRadius.extraLarge};
                border-bottom-right-radius: ${({ theme }) =>
                    theme.borderRadius.extraLarge};
                background: white;
                bottom: 0;
                padding-bottom: 20px;
            }

            @media screen and (max-width: 400px) {
                border: 0;
                border-radius: 0;
            }
        }
    }

    @media screen and (max-width: 400px) {
        padding: 0;
    }
`;

export const PageLayoutArticle = styled.article`
    border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
    padding: ${({ theme }) => theme.spacers.medium};
    background-color: white;
    max-width: calc(100% / 3 * 2);
    width: 100%;
    display: flex;
    flex-direction: column;

    /* position: relative; */
    ${down('lg')} {
        max-width: 100%;
        padding: 30px;
        min-height: calc(100% - 80px);
    }
    ${down('sm')} {
        width: 100%;
        padding: 16px;
    }
`;

interface isAdminProp {
    isAdmin: boolean | undefined;
}
export const SectionsLayoutWrapper = styled.div<isAdminProp>`
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: ${(props) => (props.isAdmin ? '100%' : '1000px')};
    padding: 0px 30px;
    width: 100%;
    ${down('lg')} {
        padding: 0px;
        width: 100%;
    }
`;

export const CategoryButtonWrapper = styled.div`
    padding: 10px 10px 0;
    display: flex;
    gap: 8px;
    flex-direction: row;
    ${down('lg')} {
        border-bottom-left-radius: ${({ theme }) =>
            theme.borderRadius.extraLarge};
        border-bottom-right-radius: ${({ theme }) =>
            theme.borderRadius.extraLarge};
        background: white;
    }
`;

export const CategoryButton = styled.button`
    padding: ${({ theme }) => theme.spacers.small};
    cursor: pointer;

    width: 50%;

    color: rgba(35, 164, 87, 1);
    text-align: center;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.03em;
    text-transform: uppercase;
    background-color: transparent;

    border: 2px solid #23a457;
    border-radius: 20px;

    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;

    &.active {
        background-color: #23a457;
        color: #fff;

        svg {
            path {
                fill: #fff;
            }
        }
    }

    span {
        float: left;
        margin-right: 5px;

        ${down('xl')} {
            margin-right: 2px;
        }
        svg {
            path {
                fill: currentColor;
            }
        }
    }

    ${down('xl')} {
        font-size: 14px;
    }
`;

export const MenuButtonWrapper = styled.div`
    display: none;
    ${down('lg')} {
        display: flex;
        position: absolute;
        align-items: center;
        justify-content: center;
        z-index: 5;
        height: 72px;
        top: 0;
        left: 0;
        width: 100%;
        border-radius: ${({ theme }) => theme.borderRadius.extraLarge};
        overflow: hidden;
    }
`;
export const MenuButton = styled.button`
    cursor: pointer;
    display: flex;

    height: 100%;
    width: 100%;
    flex: 1 1;
    justify-content: space-between;
    align-items: center;

    font-size: 21px;
    font-weight: 700;
    padding: ${({ theme }) => theme.spacers.small};
    color: ${({ theme }) => theme.palette.common.black};

    svg {
        width: 36px;
        height: 36px;
    }

    ${down('lg')} {
        background: white;
    }
`;
interface modalMenuProps {
    modalMenu: boolean | undefined;
}
export const ModalMenuButtonWrapper = styled.div<modalMenuProps>`
    display: none;
    height: 50px;
    bottom: 0;
    left: 0;
    width: 100%;
    ${down('lg')} {
        display: block;

        transition: opacity 0.3s;
        ${({ modalMenu }) =>
            !modalMenu ? 'pointer-events: all;' : 'pointer-events: none;'};
        ${({ modalMenu }) => (!modalMenu ? 'opacity: 1;' : 'opacity: 0;')};
        ${({ modalMenu }) => (!modalMenu ? 'z-index: 1;' : 'z-index: 0;')};
    }
`;
export const ModalMenuButton = styled.button`
    cursor: pointer;
    bottom: 0;
    left: 50%;
    left: 50%;
    transform: translate(-50%, 0%);
    position: fixed;
    display: flex;

    height: 50px;
    justify-content: center;
    align-items: center;
    text-transform: uppercase;
    font-size: 16px;

    color: ${({ theme }) => theme.palette.common.white};

    background-color: #23a457;
    border-top-left-radius: ${({ theme }) => theme.borderRadius.large};
    border-top-right-radius: ${({ theme }) => theme.borderRadius.large};

    ${down('lg')} {
        width: calc(100% - ${({ theme }) => theme.spacers.medium} * 2);
    }
    ${down('sm')} {
        width: calc(100% - ${({ theme }) => theme.spacers.small} * 2);
    }
    @media screen and (max-width: 400px) {
        width: 100%;
    }

    transition: filter 0.3s;
    &:hover {
        transition: filter 0.3s;
        filter: brightness(1.1);
    }
`;
